import { CSSProperties, ReactElement } from 'react';
import './Skeleton.css';

export interface SkeletonBarProps {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  strong?: boolean;
  className?: string;
}

/**
 * The skeleton atom: a single muted, pulsing bar. Every PIM skeleton composes
 * from this so the loading colour and animation stay consistent app-wide.
 */
export function SkeletonBar({ width = '100%', height = 12, radius, strong = false, className }: SkeletonBarProps): ReactElement {
  const style: CSSProperties = {
    width,
    height,
    ...(radius != null && { borderRadius: radius }),
  };
  const rootClass = ['pim-skeleton-bar', strong ? 'pim-skeleton-bar--strong' : '', className].filter(Boolean).join(' ');
  return <span className={rootClass} style={style} aria-hidden="true" />;
}

export default SkeletonBar;
